import {Vue} from "ui.vue";
import Location from './components/Location.vue';
import StoreByLocation from './components/StoreByLocation.vue';
import LocationByStep from './components/LocationByStep.vue';
import VueSelect from 'citrus.vue.vue-select';

Vue.use(VueSelect);

Vue.cloneComponent('Location', "FormFieldSelect", Location);
Vue.cloneComponent('StoreByLocation', 'Location', StoreByLocation);
Vue.cloneComponent('LocationByStep', 'Location', LocationByStep);